import {
  DetailPanel,
  DetailPanelGrid,
  type DetailPanelGridProps,
  type DetailPanelProps,
} from '@/components/shared';

export type UserDetailPanelGridProps = DetailPanelGridProps;
export type UserDetailPanelProps = DetailPanelProps;

export const UserDetailPanelGrid = DetailPanelGrid;
export const UserDetailPanel = DetailPanel;
